import capitalize from 'capitalize';
export const getName = (nameArray: any[]) => {
  let str = '';
  for (let i = 0; i < nameArray.length; i += 1) {
    if (nameArray.at(i)) {
      str += capitalize(nameArray.at(i)) + ' ';
    }
  }

  return str;
};
